import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axiosInstance from "../../../utils/axiosInstance";
import { update_users } from "../../shared/ApiEndpoint";
import { userModal } from "../../shared/validation";
import _ from "lodash";
import { notification } from "antd";

function EditUserModal({
  show,
  setShow,
  selectedEditUser,
  setSelectedEditUser,
  fetch_Users,
  searchTerm,
  currentPage,
  selectedRoleId,
  roles
}) {
  const [errorValidate,setErrorValidate]= useState({
    FirstName: false,
    LastName: false,
    email: false,
    role: false,
  })
  const [originalUser, setOriginalUser] = useState(selectedEditUser);
  const handleClose = () => setShow(false);


  const handleonchange = (e) => {
    const { name, value } = e.target;
    setSelectedEditUser({
      ...selectedEditUser,
      [name]: value,
    });

    if(value.trim()!==""){
      setErrorValidate((prev) => ({ ...prev, [name]:false}));
    }
  };


  const handleSubmit = async(e)=>{
    e.preventDefault()
    let is_valid = true;

     const isUnchanged = _.isEqual(originalUser, selectedEditUser);
  if (isUnchanged) {
    notification.info({
        key: 'register-success',
        description: 'No changes made to the user.',
        placement: 'topRight',
      });
    return;
  }

    const validations = {
      FirstName: !selectedEditUser?.FirstName,
      LastName: !selectedEditUser?.LastName,
      email: !selectedEditUser?.email,
      role: !selectedEditUser?.role,
    };
    Object.entries(validations).forEach(([key, hasError]) => {
      if (hasError) is_valid = false;
    });
    setErrorValidate((prev) => ({
      ...prev,
      ...validations,
    }));
    if (!is_valid) return;

    const payload = {
  ...(selectedEditUser?.id && { user_id: selectedEditUser.id }),
  ...(selectedEditUser?.FirstName && { first_name: selectedEditUser.FirstName }),
  ...(selectedEditUser?.LastName && { last_name: selectedEditUser.LastName }),
  ...(selectedEditUser?.email && { email: selectedEditUser.email }),
  ...(selectedEditUser?.role !== undefined && { role: selectedEditUser.role }),
  ...(selectedEditUser?.userName && { username: selectedEditUser.userName }),
  ...(selectedEditUser?.phone_no && { phone_no: selectedEditUser.phone_no }),
};

    try {
      const resp= await axiosInstance.put(update_users,{...payload},{withCredentials:true})
      if(resp?.status===200){
        setShow(false);
        fetch_Users(searchTerm,currentPage,selectedRoleId);
        notification.success({
        key: 'register-success',
        description: 'User Updated successfully!',
        placement: 'topRight',
      });
      }
    } catch (error) {
      console.log(error)
      if(error?.response?.status===400){
        console.log(error?.response?.data)
      }
    }
  }




  return (
    <>
    
      <Modal show={show} onHide={handleClose} centered>
         <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="firstname" className="form-label">
                  First Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="firstname"
                  placeholder="Enter First Name"
                  name="FirstName"
                  value={selectedEditUser?.FirstName}
                  onChange={handleonchange}
                />
                {errorValidate.FirstName && <p className="text-danger">{userModal.first_name}</p>}
              </div>
              <div className="col-md-6">
                <label htmlFor="lastname" className="form-label">
                  Last Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="lastname"
                  placeholder="Enter Last Name"
                  name="LastName"
                  value={selectedEditUser?.LastName}
                  onChange={handleonchange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="username" className="form-label" >
                  User Name 
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="username"
                  placeholder="Enter Username"
                  name="userName"
                  value={selectedEditUser?.userName}
                  onChange={handleonchange}
                  disabled
                />
                
              </div>
              <div className="col-md-6">
                <label htmlFor="role" className="form-label">
                  Role <span className="text-danger">*</span>
                </label>
                <select 
                className="form-select"
                  id="role"
                  placeholder="Enter role"
                  name="role"
                  onChange={handleonchange}
                  value={selectedEditUser?.role}
                  >
                    {roles.map((r) => (
                      <option key={r.role_id} value={r.role_id}>
        {r.rolename}
      </option>
                    ))}
                  </select>
                  {errorValidate.role && <p className="text-danger">{userModal.role}</p>}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-12 ">
                <label htmlFor="email" className="form-label">
                  {" "}
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Enter email"
                  name="email"
                  value={selectedEditUser?.email}
                  onChange={handleonchange}
                />
                {errorValidate.email && <p className="text-danger">{userModal.email}</p>}
              </div>
            </div>
         
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save Changes
          </Button>
        </Modal.Footer>
        </form>
      </Modal>
       
    </>
  );
}

export default EditUserModal;
